import { For } from "solid-js";

function providerColor(name: string) {
  switch (name) {
    case "anonymous": return "bg-amber-900/40 text-amber-300 border border-amber-700";
    case "google": return "bg-purple-900/40 text-purple-300 border border-purple-700";
    case "email": return "bg-cyan-900/40 text-cyan-300 border border-cyan-700";
    default: return "bg-gray-800 text-gray-400 border border-gray-700";
  }
}

interface UserInfoCardProps {
  user: any;
  memberStatus?: string;
  providers: string[];
}

export function UserInfoCard(props: UserInfoCardProps) {
  const u = props.user;
  return (
    <tr>
      <td colspan="7" class="bg-gray-950 p-0">
        <div class="px-4 py-3 border-t border-gray-800">
          <div class="grid grid-cols-2 sm:grid-cols-3 gap-3 text-xs">
            <div>
              <span class="text-gray-500">Display Name</span>
              <div class="text-gray-200 mt-0.5">{u.displayName ?? "—"}</div>
            </div>
            <div>
              <span class="text-gray-500">Contact Info</span>
              <div class="text-gray-200 mt-0.5">{u.contactInfo ?? "—"}</div>
            </div>
            <div>
              <span class="text-gray-500">Auth Providers</span>
              <div class="text-gray-200 mt-0.5 space-x-1">
                <For each={props.providers}>{(p) => (
                  <span class={`px-1.5 py-0.5 rounded text-[10px] font-medium ${providerColor(p)}`}>{p}</span>
                )}</For>
              </div>
            </div>
            <div>
              <span class="text-gray-500">Primary Email</span>
              <div class="text-gray-200 mt-0.5">{u.email ?? "—"}</div>
            </div>
            <div>
              <span class="text-gray-500">Email Verified</span>
              <div class="text-gray-200 mt-0.5">{u.emailVerified ? "Yes" : "No"}</div>
            </div>
            <div>
              <span class="text-gray-500">Profile Locked</span>
              <div class="text-gray-200 mt-0.5">{u.profileLocked ? "Yes" : "No"}</div>
            </div>
            <div>
              <span class="text-gray-500">Org Status</span>
              <div class="text-gray-200 mt-0.5">{props.memberStatus ?? "—"}</div>
            </div>
            <div>
              <span class="text-gray-500">Created</span>
              <div class="text-gray-200 mt-0.5">{new Date(u.createdAt ?? u.created_at).toLocaleString()}</div>
            </div>
            <div>
              <span class="text-gray-500">Updated</span>
              <div class="text-gray-200 mt-0.5">{new Date(u.updatedAt ?? u.updated_at).toLocaleString()}</div>
            </div>
          </div>
        </div>
      </td>
    </tr>
  );
}
